<form novalidate name="ChecklistTaskEditForm" method="POST" id="ChecklistTaskEditForm" class autocomplete="off" (ngSubmit)="ChecklistTaskEditForm.valid && saveItem(this.ChecklistTaskEditForm)" #ChecklistTaskEditForm="ngForm">	<div class="modal-header">
		<div class="row w-100">
			<div class="col">
				<h2>Add Task</h2>
			</div>
			<div class="col text-right">
				<PageHelp [menuKey]="'AddTask'"></PageHelp>
			</div>
			<div class="col-auto">
				<button type="button" class="close" aria-label="Close" (click)="closePopUp(null)">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
		</div>
		
		
	</div>
	<div class="modal-body">
		<div class="row" *ngIf="!myItem.HasSourceQuestion">
			<div class="form-group col-sm-12" form-group-validation="myItem.StepText">
				<strong>Task Description:</strong>
				<textarea required placeholder="Required" name="myItem.StepText" id="myItem_StepText" class="form-control" [(ngModel)]="myItem.StepText" #StepText="ngModel"></textarea>
				<span class="text-danger" *ngIf="(StepText && StepText.errors && StepText.errors.required) && ChecklistTaskEditForm.submitted">Step Description is required.</span>
			</div>
		</div>
		<div class="row">
			<div class="form-group col-sm-6" form-group-validation="myItem.PersonID">
				<label for="myItem_PersonID" class="control-label">Assigned To</label>
				<select name="myItem.PersonID" id="myItem_PersonID" class="form-control" [(ngModel)]="myItem.PersonID" #PersonID="ngModel"><option value="{{ddlVar.PersonID}}" *ngFor="let ddlVar of staff">{{ddlVar.FullName}}</option></select>
				
			</div>
			<div class="form-group col-sm-6" form-group-validation="myItem.DateDue">
				<label for="myItem_DateDue" class="control-label">Date Due</label>
				<div class="input-group"><input placeholder="mm/dd/yyyy" ngbDatepicker name="myItem.DateDue" id="myItem_DateDue" firstDayOfWeek="7" class="form-control" [(ngModel)]="myItem.DateDue" #myItemDateDue="ngbDatepicker" #DateDue="ngModel" /><button type="button" class="input-group-addon" (click)="myItemDateDue.toggle()"><i class="fa fa-calendar"></i></button></div><span class="text-danger" *ngIf="(DateDue && DateDue.errors && DateDue.errors.ngbDate?.invalid) && DateDue.dirty">Invalid Format</span>
				
			</div>
		</div>
		<div class="row">
			<div class="form-group col-12">
				<label class="control-label">
					Link Choice
				</label>
				<select [(ngModel)]="linkChoice" class="form-control" id="linkChoice" name="linkChoice" [disabled]="myItem.IsStarted">
					<option [value]="0">None</option>
					<option [value]="1" *ngIf="this.configData.isLMSCompany && courses && courses.length">Course</option>
					<option [value]="2" *ngIf="this.configData.isLMSCompany && webinars && webinars.length">Webinar</option>
					<option [value]="3" *ngIf="docs && docs.length">Document</option>
					<option [value]="4">External Document</option>
				</select>
			</div>

			<div class="form-group col-12" *ngIf="linkChoice == 1" form-group-validation="myItem.CourseID">
				<label class="control-label">
					Course
				</label>
				<select name="myItem.CourseID" id="myItem_CourseID" class="form-control" [disabled]="myItem.IsStarted" [(ngModel)]="myItem.CourseID" #CourseID="ngModel"><option value="{{ddlVar.CourseID}}" *ngFor="let ddlVar of courses">{{ddlVar.CourseName}}</option></select>
				
			</div>
			<div class="form-group col-12" *ngIf="linkChoice == 2" form-group-validation="myItem.CourseID">
				<label class="control-label">
					Webinar
				</label>
				<select name="myItem.CourseID" id="myItem_CourseID" class="form-control" [disabled]="myItem.IsStarted" [(ngModel)]="myItem.CourseID" #CourseID="ngModel"><option value="{{ddlVar.CourseID}}" *ngFor="let ddlVar of webinars">{{ddlVar.CourseName}}</option></select>
				
			</div>
			<div class="form-group col-12" *ngIf="linkChoice == 3" form-group-validation="myItem.DocumentHistoryID">
				<label class="control-label">
					Document
				</label>
				<select name="myItem.DocumentHistoryID" id="myItem_DocumentHistoryID" class="form-control" [disabled]="myItem.IsStarted" [(ngModel)]="myItem.DocumentHistoryID" #DocumentHistoryID="ngModel"><option value="{{ddlVar.DocumentHistoryID}}" *ngFor="let ddlVar of docs">{{ddlVar.Title}}</option></select>
				
			</div>
			<div class="form-group col-12" *ngIf="linkChoice == 4" form-group-validation="myItem.DocumentLink">
				<label class="control-label">
					Document
				</label>
				<input type="text" name="myItem.DocumentLink" id="myItem_DocumentLink" class="form-control" [disabled]="myItem.IsStarted" [(ngModel)]="myItem.DocumentLink" #DocumentLink="ngModel" />
				
			</div>
		</div>
		<div class="bg-danger validationErrors" [hidden]="!validationErrors">
			<ul>
				<li *ngFor="let error of validationErrors">{{error}}</li>
			</ul>
		</div>
		<button type="submit" class="btn btn-primary" [disabled]="ChecklistTaskEditForm.invalid" value="Save"> Save </button>
	</div>
</form>